import { CarolChatMockup, MenuMockup, KDSMockup, DREMockup, BrainMockup } from "./PartnerMockups";

const TAG_COLORS = ["#22c55e", "#3b82f6", "#f59e0b", "#a78bfa", "#f472b6"];
const Mockups = [CarolChatMockup, MenuMockup, KDSMockup, DREMockup, BrainMockup];

const TAG = (color) => ({
  display: "inline-block", background: color + "18", border: `1px solid ${color}33`,
  borderRadius: 6, padding: "2px 10px", fontSize: 11, fontWeight: 700, color,
});
const BADGE = {
  display: "inline-block", background: "#1a2e1a", border: "1px solid #22c55e33",
  borderRadius: 20, padding: "3px 12px", fontSize: 11, fontWeight: 700, color: "#4ade80",
};

export function DifferentialsSection({ t }) {
  return (
    <section style={{ marginBottom: 64 }}>
      <h2 style={{ fontSize: "clamp(20px,4vw,28px)", fontWeight: 800, color: "#fff", margin: "0 0 8px" }}>
        {t.diff_title}
      </h2>
      <p style={{ color: "#777", fontSize: 15, margin: "0 0 32px" }}>{t.diff_sub}</p>

      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        {t.cards.map(({ tag, badge, title, body }, i) => {
          const Mockup = Mockups[i];
          const color = TAG_COLORS[i];
          const flip = i % 2 !== 0;
          return (
            <div key={tag} style={{
              background: "#111", border: "1px solid #1e1e1e", borderRadius: 16,
              padding: 24, display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: 24,
            }}>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", order: flip ? 1 : 0 }}>
                <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
                  <span style={TAG(color)}>{tag}</span>
                  <span style={BADGE}>{badge}</span>
                </div>
                <h3 style={{ fontWeight: 800, fontSize: 16, color: "#fff", margin: "0 0 10px", lineHeight: 1.4 }}>{title}</h3>
                <p style={{ color: "#888", fontSize: 14, lineHeight: 1.65, margin: 0 }}>{body}</p>
              </div>
              <div style={{ order: flip ? 0 : 1 }}>
                <Mockup t={t} />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
